rwgps.ns('groups.show', function() {
  var ns = this;
  ns.init = function(mapOpts) {
    $(function () {
      // init photos
      var ns = rwgps.ns('groups.show');
      var PhotosView = rwgpsG_views_photos;
      new PhotosView({
        container: '#group_photos',
        parentType: 'group',
        parentId: ns.groupId,
        photosetId: ns.photosetId,
        photos: ns.photos, 
        canEdit: ns.isOwner
      });

      var routePreviewInitDone = false;
      var routePreviewInit = function() {
        if($('#route_preview_list').size() == 0) return; // doesnt exist yet, tab content not loaded
        if(routePreviewInitDone) {
          $('li.route_list_item:first').click();
          return;
        }
        $('.ride_list li').live('click', function(){
          window.location = $(this).children('a').attr('href');
        });
        ns.activeMap = new rwgps.Map(mapOpts);
        $('#route_filter_input').liveUpdate('#route_preview_list > ul', function() {
          return $('h2', this).get(0).innerHTML;
        });

        routePreviewInitDone = true;
        $('li.route_list_item:first').click();
      };
      var selectedEl = $('#tabs li.active').get(0);
      $('#tabs').bind('tabsshow', function(e,ui) {
        $('#route_preview_list li.open').removeClass('open');
	$('table.user_summary tbody tr:nth-child(even)').addClass('alt');
        if(ui.tab.id == 'route_previewer_tab') {
          routePreviewInit();
        }
      });
      $('#tabs').bind('tabsload', function(e,ui) {
        if(ui.tab.id == 'route_previewer_tab') {
          routePreviewInit();
        }
      });
      var selectedI = $(selectedEl).parent().find('> li').index(selectedEl);
      $("#tabs").tabs({ cache: true, selected: selectedI, ajaxOptions: {dataType: "text" } });
      $('#route_preview_list li:first').click();
    });
  };
  ns.routePreviewClicked = function(self, route_id, trip_id, distance) {
    if($(self).hasClass('open'))
      return;

    if(!$(self).hasClass('open')) {
      $('#route_preview_list li').removeClass('open').children('div').hide();
      $(self).addClass('open').children().show();
    }
    ns.viewRoute(route_id, distance, trip_id);
  };
  ns.loadRoute = function(data) {
    var route = new rwgps.Route(data);
    ns.activeMap.callWhenReady(function() {
      ns.activeMap.loadRouteForView(route);
      ns.activeMap.loadPois(data.points_of_interest);
    });
  };
  ns.viewRoute = function(id, distance) {
    if(!id) {
        var obj = $('#route-preview-list li:not(.selected)');
        if(obj.length > 0) $(obj[0]).click();
        else ns.activeMap.clearMap();
        return;
    }

    var li_obj = $('#obj-route-' + id);
    var sub_obj = $('#route-details-' + id);
    var sub_min_obj = $('#route-details-min-' + id);
    var sel_li_obj = $('#obj-route-' + this.selectedId);
    var sel_sub_obj = $('#route-details-' + this.selectedId);
    var sel_min_obj = $('#route-details-min-' + this.selectedId);

    if(this.selectedId)  {
      sel_li_obj.removeClass('selected');
      sel_sub_obj.hide();
      sel_min_obj.show();
    }

    li_obj.addClass('selected');
    sub_obj.show();
    sub_min_obj.hide();
    this.selectedId = id;

    $.getJSON('/routes/' + id + '.json', function(data) {
      ns.loadRoute(data);
    });
    $('#distance_txt').html(distance);
  };
});



// WEBPACK FOOTER //
// ./public/javascripts/groups/show.js